import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import styles from '../Cards/KPICards.module.css';

const COLORS = ['#00C49F', '#0088FE', ];

const PieChartWithCenterLabel = ({ label, data }) => {
	const renderCenterLabel = ({ cx, cy }) => {
		return (
			<text x={cx} y={cy} textAnchor="middle" dominantBaseline="middle" fontSize={14} fill="#333" fontWeight={600} color={'#2b2b2b'}>
			{data?.imcbu}
			</text>
		);
	};
    const transformData = [
		{
			"name": "Impacted CBUs",
			"value": data?.imcbu
		},
		{
			"name": "High Priority CBUs",
			"value": data?.hpcbu
		}
	];
  return (
	<div className={styles.paichartContainer}>
		<div>
			<span className={styles.kpiText}>{label}</span>
			<div>
				<span className={styles.emptyBox}></span>
				<span className={styles.paikpiText}>High Priority CBUs</span>
				<span className={styles.paicount}>{data?.hpcbu}</span>
			</div>
		</div>
		<div className={styles.paiRight}>
			<PieChart width={60} height={60}>
				<Pie
					data={transformData}
					cx="50%"
					cy="50%"
					outerRadius={30}
					innerRadius={20}
					fill="#0088FE"
					dataKey="value"
					labelLine={false}
					label={renderCenterLabel} 
				>
					{transformData.map((entry, index) => (
						<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
					))}
				</Pie>
			</PieChart>
		</div>
	</div>
  );
};

export default PieChartWithCenterLabel;